module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_9_2.0005c45f.png";